import actioncable from 'actioncable';
import { createContext, ReactNode } from 'react';

interface ActionCableProps {
  children: ReactNode;
}

export interface ActionCable {
  cable: actioncable.Cable;
  removeWSConnection: () => void;
  createWSConnection: () => void;
}

const actionCable: ActionCable = {
  cable: actioncable.createConsumer(import.meta.env.VITE_BASE_WS_URL || ''),
  removeWSConnection: () => {
    actionCable.cable.disconnect();
  },
  createWSConnection: () => {
    actionCable.cable.connect();
  },
};

export const ActionCableContext = createContext<ActionCable>(actionCable);

export const ActionCableProvider = ({ children }: ActionCableProps) => {
  return <ActionCableContext.Provider value={actionCable}>{children}</ActionCableContext.Provider>;
};
